import React from "react";
import { Link } from "react-router-dom";
import { Rocket, ArrowLeft } from "lucide-react";

export default function WhatsAppReport() {
  return (
    <div className="max-w-2xl mx-auto py-12 sm:py-16" data-testid="whatsapp-coming-soon">
      <div className="border border-border rounded-xl bg-card p-8 sm:p-12 text-center">
        <div className="w-14 h-14 rounded-full bg-primary/10 grid place-items-center mx-auto">
          <Rocket className="w-7 h-7 text-primary" />
        </div>
        <div className="mono text-[10px] uppercase tracking-[0.25em] text-primary mt-6">Coming Soon</div>
        <h1 className="font-heading text-2xl sm:text-3xl mt-3 tracking-tight">WhatsApp Daily Reports</h1>
        <p className="text-muted-foreground mt-4 text-sm sm:text-base max-w-md mx-auto leading-relaxed">
          Ye feature abhi development me hai — bahut jald aayega. Meanwhile, aap **Daily Reports** section me detailed PDF reports generate karke email ya share kar sakte hai.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/app/reports" data-testid="go-to-reports"
            className="btn-sharp inline-flex items-center gap-2 bg-primary text-primary-foreground px-5 py-2.5 text-sm font-medium">
            Go to Daily Reports
          </Link>
          <Link to="/app" data-testid="back-to-dashboard"
            className="btn-sharp inline-flex items-center gap-2 border border-border px-5 py-2.5 text-sm font-medium hover:bg-muted">
            <ArrowLeft className="w-4 h-4" /> Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
